import React from "react";

const Loading = () => {
  return (
    <>
      <style>{`
        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .loading-container .yin-yang {
          width: 96px;
          height: 48px;
          background: #eee;
          border-color: #000;
          border-style: solid;
          border-width: 2px 2px 50px 2px;
          border-radius: 100%;
          position: relative;
          animation: spin 3s linear infinite;
          box-shadow: 0 0 120px white;
        }

        .loading-container .yin-yang:before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          background: #eee;
          border: 18px solid #000;
          border-radius: 100%;
          width: 12px;
          height: 12px;
        }

        .loading-container .yin-yang:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          background: #000;
          border: 18px solid #eee;
          border-radius: 100%;
          width: 12px;
          height: 12px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
      <div className="loading-container">
        <div className="yin-yang"></div>
      </div>
    </>
  );
};

export default Loading;

// import React from 'react';

// const Styles = `
//   .yin-yang {
//     width: 96px;
//     height: 48px;
//     background: #eee;
//     border-color: #000;
//     border-style: solid;
//     border-width: 2px 2px 50px 2px;
//     border-radius: 100%;
//     position: relative;
//     animation: spin 3s linear infinite;
//     box-shadow: 0 0 120px white; /* Added white glow */
//   }

//   .yin-yang:before {
//     content: "";
//     position: absolute;
//     top: 50%;
//     left: 0;
//     background: #eee;
//     border: 18px solid #000;
//     border-radius: 100%;
//     width: 12px;
//     height: 12px;
//   }

//   .yin-yang:after {
//     content: "";
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     background: #000;
//     border: 18px solid #eee;
//     border-radius: 100%;
//     width: 12px;
//     height: 12px;
//   }

//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;

// const Loading = () => {
//   return (
//     <>
//       <style>{Styles}</style>
//       <div className="yin-yang"></div>
//     </>
//   );
// };

// export default Loading;
